import { TemplatePageProps } from './types'
import { SolitaireInfiniteEntity } from './entity'
import Icon from 'images/games/solitaire-infinite/icon.png'
import Swiper1 from 'images/games/solitaire-infinite/swiper1.webp'
import Swiper2 from 'images/games/solitaire-infinite/swiper2.webp'
import Swiper3 from 'images/games/solitaire-infinite/swiper3.webp'
import Swiper4 from 'images/games/solitaire-infinite/swiper4.webp'
import Swiper5 from 'images/games/solitaire-infinite/swiper5.webp'
import Swiper6 from 'images/games/solitaire-infinite/swiper6.webp'
import Swiper7 from 'images/games/solitaire-infinite/swiper7.webp'
import Detail1 from 'images/games/solitaire-infinite/detail1.png'
import Detail2 from 'images/games/solitaire-infinite/detail2.png'
import Detail3 from 'images/games/solitaire-infinite/detail3.png'
import Footer from 'images/games/solitaire-infinite/footer.png'
import {
  GamesLink,
  PlaySolitaireOnlineLink,
  SolitaireClashLink,
  SolitaireSlamLink,
  SolitaireVentureLink,
  TextLink,
} from '../../components'

export const SolitaireInfiniteDetail: TemplatePageProps = {
  entity: {
    ...SolitaireInfiniteEntity,
    logo: Icon,
    title: <>Solitaire Infinite: Exciting Classic Solitaire Card Games</>,
    description: (
      <>
        Get ready for limitless <strong>card game</strong> action with <strong>Solitaire Infinite</strong>, the exciting
        twist on <strong>classic Solitaire</strong> that lets you test your skills in multiplayer tournaments! Solve the
        deck, rack up points, and compete in skill-based matches for real cash prizes! When you{' '}
        <strong>play solitaire</strong>, it’s your move!
      </>
    ),
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
    { image: Swiper7 },
  ],
  content: [
    {
      title: <>Classic Solitaire, Modern Twist</>,
      description: (
        <>
          In <strong>Solitaire Infinite</strong>, the goal is to move all cards to the Foundation in ascending order by
          suit. To do this, stack cards in alternating colors and descending order in the Tableau. If you&#39;re out of
          moves, draw three cards at a time from the Stock to help solve the deck. Finish before time runs out—or end
          early for a bonus! Place your cards strategically, tap &#34;Undo&#34; if needed, and finish fast to boost your
          score. You can also join multiplayer, skill-based tournaments and compete in various modes where the top 3
          players walk away with prizes! Whether you&#39;re here to test your logic or to win, Solitaire Infinite
          delivers classic gameplay with a competitive edge!
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Level Playing Field, Real Prizes</>,
      description: (
        <>
          <strong>Solitaire Infinite</strong> turns your card skills into real rewards with fun, fast-paced, skill-based{' '}
          <strong>real money games</strong>. Use Gems to enter free matches, or join cash tournaments to{' '}
          <strong>win real money</strong>. Daily logins unlock free in-game items, plus join exciting weekly events like
          Flip Frenzy and Dice Tycoon. All players are given the same solitaire setup, ensuring fair, skill-based
          competition through secure and balanced matchmaking. With smooth gameplay, eye-catching designs, and a
          user-friendly interface, Solitaire Infinite creates an engaging experience that keeps you coming back!
        </>
      ),
      image: Detail2,
    },
    {
      title: <>Easy Deposits, Smooth Withdrawals, Accessible Support</>,
      description: (
        <>
          Cash out your winnings confidently through <strong>PayPal</strong>, with secure encryption protecting every
          transaction. Need to make a deposit? Choose from trusted payment options like <strong>PayPal</strong>,{' '}
          <strong>Apple Pay</strong>, <strong>Visa</strong>, <strong>Mastercard</strong>,{' '}
          <strong>American Express (US only)</strong>, <strong>Venmo</strong>, and <strong>Discover</strong>. The
          process is smooth and reliable when you enter a cash match or collect your prize.
          <br />
          <br />
          Avia&#39;s player support team is always ready to help with any questions or concerns you may have. From
          gameplay to deposits and account management, they&#39;re committed to providing friendly and efficient
          assistance. Fill out the <TextLink href="/support/#support-contact-us">request form</TextLink> and tell us
          your questions or concerns in detail, and we&#39;ll make sure you continue to enjoy our games!
        </>
      ),
      image: Detail3,
    },
    {
      title: <>Dive In and Compete! </>,
      description: (
        <>
          <strong>Solitaire Infinite</strong> brings a competitive edge to the{' '}
          <strong>classic Solitaire card game</strong> you know and love! With smooth gameplay, vibrant visuals, and
          fair matches, Solitaire Infinite creates a fun and secure experience for all skill levels. It’s part of Avia’s
          diverse lineup of <strong>solitaire card games</strong>, including <SolitaireClashLink />,{' '}
          <SolitaireVentureLink />, <SolitaireSlamLink />, and <PlaySolitaireOnlineLink />
          —each offering a unique way to play. Stack your way to victory! Download Solitaire Infinite now for
          skill-based fun and to <GamesLink>win real money</GamesLink> rewards!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
} as TemplatePageProps
